import { useRef } from "react"
import { useParams } from "react-router"
import { Bound } from "lib/@components/binding/Bound"
import { useSave } from "lib/@hooks/use-save"
import { getScheduleDraft } from "../controller/get-schedule-draft"
import { updateDraftLegacyScheduleGroups } from "../controller/update-draft-legacy-schedule-groups"
import { SeedSource } from "authoring/lib/enum/seed-source.mjs"
import { useScheduleEditorSeed } from "../hooks/use-schedule-editor-seed"
import { ScheduleGroupsAutocomplete } from "authoring/routes/project/components/schedule-groups-autocomplete"

export function ScheduleEditorLegacyScheduleGroups() {
    const { projectId, scheduleId } = useParams()
    const { seedSource } = useScheduleEditorSeed()
    const draftRecord = getScheduleDraft.useResultsOnce({ projectId, scheduleId })

    const stableRef = useRef({})
    const target = draftRecord ?? stableRef.current

    const onChange = useSave({ save: saveGroups, target, wait: 1000 })

    if (seedSource !== SeedSource.NEW) return null

    return (
        <Bound target={target} onChange={onChange}>
            <ScheduleGroupsAutocomplete sx={{ mt: 0 }} />
        </Bound>
    )

    async function saveGroups(record) {
        await updateDraftLegacyScheduleGroups({
            projectId,
            scheduleId,
            legacyScheduleGroups: record.legacyScheduleGroups ?? [],
        })
    }
}
